import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => createStyles({
  compareWrapper: {
    flex: '1',
    height: '100%',
    padding: '20px',
    overflowY: 'auto',
    position: 'relative',
  },
}));
